import React from 'react';
import ExternalLink from './ExternalLink';
import Widget from './Widget';

const WidgetSocial = () => (
  <Widget>
    <ul className="widget--social-items has-text-centered">
      <li className="widget--social-text">
        <ExternalLink href="https://github.com/jodyboucher">GitHub</ExternalLink>
      </li>
      <li className="widget--social-text">
        <ExternalLink href="https://www.linkedin.com/in/jodyboucher">LinkedIn</ExternalLink>
      </li>
      <li className="widget--social-text">
        <ExternalLink href="https://twitter.com/jodyboucher_l42">Twitter</ExternalLink>
      </li>
    </ul>
  </Widget>
);

export default WidgetSocial;



// WEBPACK FOOTER //
// ./src/components/WidgetSocial.js